import React from 'react';
import { AppsIcon, CommunityIcon, InfoIcon, UserIcon } from './Icons';

export const MobileNav: React.FC = () => {
  return (
    <nav className="fs-mobile-nav">
      <a href="#apps" className="fs-mobile-nav__item fs-mobile-nav__item--active">
        <AppsIcon />
        Apps
      </a>
      <a href="#community" className="fs-mobile-nav__item">
        <CommunityIcon />
        Community
      </a>
      <a href="#about" className="fs-mobile-nav__item">
        <InfoIcon />
        About
      </a>
      <a href="#" className="fs-mobile-nav__item">
        <UserIcon />
        Account
      </a>
    </nav>
  );
};
